import { useRouter } from 'expo-router';
import { Linking } from 'react-native';

import { isExternalLink } from 'utils/is-external-link';

export const useContentCardNavigation = () => {
  const router = useRouter();

  const navigate = ({ url }: { url: string }) => {
    if (!url) {
      return;
    }

    if (isExternalLink(url)) {
      Linking.openURL(url);
      return;
    }

    // Inbox is a (drawer) overlay; replace/navigate without dismiss keeps the
    // destination inside that modal. Close it first so in-app CTAs land on the main stack.
    if (router.canDismiss()) {
      router.dismiss();
    }
    router.navigate(url);
  };

  return {
    navigate,
  };
};
